import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { CurrencyPipe } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-average-purchase-price',
  templateUrl: './average-purchase-price.component.html',
  styleUrl: './average-purchase-price.component.scss'
})
export class AveragePurchasePriceComponent implements OnInit, OnDestroy {
  constructor(private dashboardService: DashboardService, private currencyPipe: CurrencyPipe) { }
  hasData: boolean;
  noData: boolean;
  formattedAvgPrice: string;
  formattedHighPrice: string;
  footerContent: string;
  private unsubscribe$ = new Subject<void>()

  ngOnInit(): void {
    this.dashboardService.buyerStatsData.pipe(takeUntil(this.unsubscribe$)).subscribe(result => {
      this.hasData = true;
      this.noData = !result.averagePurchasePrice;
      if (result.averagePurchasePrice > 0) {
        this.formattedAvgPrice = this.currencyPipe.transform(result.averagePurchasePrice, 'GBP', 'symbol', '1.2-2');
        this.formattedHighPrice = this.currencyPipe.transform(result.highestPurchasePrice, 'GBP', 'symbol', '1.2-2');
      }
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
